<template>
  <validation-form @on-submit="addNewCommunication">
    <div class="form-input mb-10">
      <div class="md-layout mt-15">
        <div class="md-layout-item md-size-33 md-small-size-100">
          <md-field>
            <label :for="selectMethod.name">{{ $t(selectMethod.label) }}</label>
            <md-select
              v-model="form.method"
              :id="selectMethod.name"
              :multiple="selectMethod.multiple"
            >
              <md-option
                v-for="option in selectMethod.options"
                :value="option.id"
                :key="option.id + option.name"
                >{{ $t(option.name) }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33 md-small-size-100">
          <template class="pt-10">
            <label> {{ $t("class.concerns") }}</label>
            <checkbox-multi-select
              :options="selectSubject.options"
              :trackBy="selectSubject.trackBy"
              :displayField="selectSubject.displayField"
              v-model="form.concerns"
              :style="{ marginTop: '-6px' }"
            >
            </checkbox-multi-select>
          </template>
        </div>
        <div class="md-layout-item md-size-33 md-small-size-100">
          <date-picker-custom
            :label="$t('class.date_of_contact')"
            v-model="form.date_of_contact"
            :disabledDate="disabledDate"
          >
          </date-picker-custom>
        </div>
        <div class="md-layout-item md-size-100">
          <label>{{ $t("student.communication_detail") }} </label>
          <validation-field
            :validations="validations.communicationDetail"
            class="border border-gray-300 p-2"
            name="Communication detail"
            isTextArea="true"
          >
            <md-textarea
              class="p-0"
              v-model="form.communication_detail"
            ></md-textarea>
            <span class="md-error" v-if="serverValidations.contents">
              {{ serverValidations.contents }}
            </span>
          </validation-field>
        </div>
        <div class="md-layout-item md-size-100 pt-10">
          <label>{{ $t("class.response_from_parent") }} </label>
          <validation-field
            :validations="validations.responseFromParent"
            class="border border-gray-300 p-2"
            name="response from parent"
            isTextArea="true"
          >
            <md-textarea
              class="p-0"
              v-model="form.response_from_parent"
            ></md-textarea>
            <span class="md-error" v-if="serverValidations.contents">
              {{ serverValidations.contents }}
            </span>
          </validation-field>
        </div>
      </div>
    </div>
    <!-- btn -->
    <div class="flex justify-center">
      <md-button class="md-raised mr-5" @click="clearForm">
        {{ $t("common.cancel") }}
      </md-button>
      <md-button type="submit" class="md-success">
        {{ $t("common.add") }}
      </md-button>
    </div>
  </validation-form>
</template>
<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import TableActions from "./TableActions.vue";
import { parameterValidations } from "@/validations/classes";
import { methodOption } from "./ultils";

export default {
  components: {
    CheckboxMultiSelect
  },
  data() {
    const today = new Date().toISOString().slice(0, 10);
    const studentId = this.$route.params.id;
    return {
      studentId: studentId,
      modalData: null,
      TableActions,
      validations: parameterValidations,
      serverValidations: "",
      form: {
        concerns: ["Academic"],
        date_of_contact: today,
        response_from_parent: "",
        communication_detail: "",
        method: "Phone-call",
        student_id: studentId
      },
      selectMethod: {
        label: "class.method",
        name: "method__",
        value: "",
        type: "select",
        options: methodOption
      }
    };
  },
  computed: {
    selectSubject() {
      return {
        label: "select",
        name: "subject",
        value: [],
        type: "checkbox-multi-select",
        options: [
          {
            id: "Academic",
            name: this.$t("student.academic")
          },
          {
            id: "Behavior",
            name: this.$t("student.behavior")
          },
          {
            id: "Attendance",
            name: this.$t("student.attendance")
          },
          {
            id: "Homework",
            name: this.$t("student.homework")
          },
          {
            id: "Academic-performance",
            name: this.$t("student.academic_performance")
          },
          {
            id: "Extracurricular",
            name: this.$t("student.extracurricular")
          },
          {
            id: "Students_account",
            name: this.$t("student.students_account")
          },
          {
            id: "Parents Feedback",
            name: this.$t("student.parents_feedback")
          },
          {
            id: "Others",
            name: this.$t("student.others")
          }
        ],
        trackBy: "id",
        displayField: "name"
      };
    }
  },
  methods: {
    clearForm() {
      this.$emit("clear-form");
    },
    addNewCommunication() {
      this.$emit("add-new", this.form);
    },
    disabledDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    }
  }
};
</script>
<style lang="scss" scoped>
label {
  font-size: 14px !important;
}
.md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
  min-height: 80px;
  padding: 0 16px;
  resize: none;
}
</style>
